var React = require('react');

function Gavel (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"currentColor","d":"M4 18.455h9.052V20H4v-1.545zm3.198-9.992l2.135-2.187L20 17.203l-2.135 2.187L7.198 8.463zM12.54 3l4.27 4.374-2.135 2.186-4.27-4.373L12.54 3zM6.135 9.553l4.27 4.373-2.135 2.187L4 11.74l2.135-2.187z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","key":1})]));
}

Gavel.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Gavel;

Gavel.default = Gavel;
